const LIVE_QUANTA_API = 'https://points.ducatprotocol.com/';

export function resolveQuantaApiUrl(value?: string): string {
  if (!value) return LIVE_QUANTA_API;
  const url = new URL(value);
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
  if (
    (url.protocol !== 'https:' && !(local && url.protocol === 'http:')) ||
    url.username ||
    url.password ||
    url.search ||
    url.hash ||
    url.pathname !== '/'
  ) {
    throw new Error('NEXT_PUBLIC_QUANTA_API_URL must be an HTTPS origin (HTTP is allowed on localhost).');
  }
  return url.href;
}
